<script setup lang="ts">
import type { AppDetail } from '~/types'

interface Props {
  value: AppDetail
}

defineProps<Props>()

const visible = ref(false)
</script>

<template>
  <div class="rd-8px bg-#fff" p="20px md:40px" :class="!visible && 'relative of-hidden'">
    <LdFold :visible="visible" class="op-100 duration-1000" min-h="230px md:140px">
      <div class="w-full">
        <h2 class="c-#161636 font-800" lt-md="mb-12px text-16px" md="mb-18px text-20px">
          {{ $t('game.detail_title') }}
        </h2>
        <div class="[word-break:break-word] c-#161636 c-op-70" md="text-18px lh-28px" lt-md="text-14px lh-20px" v-html="value.content" />
      </div>
    </LdFold>
    <div class="z-2 mt--40px" :class="visible ? 'sticky bottom-86px' : 'relative'">
      <div :class="visible && 'op-0'" class="h-40px w-full bg-gradient-to-b transition-all-300" from="transparent" to="#fff" />
      <div class="mx-auto mt-24px w-fit bg-#fff text-center">
        <button class="ld-button bg-#F2F2F3 px-20px text-12px hover:bg-purple-5 hover:bg-op-15 md:text-14px" c="purple-5" @click="visible = !visible">
          <span class="mie-4px font-400 lh-1em">{{ visible ? $t('game.content_hide') : $t('game.content_open') }}</span>
          <Icon name="ArrowDown" class="transition-all-300 delay-300" :class="visible && 'rotate-180'" />
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
